export class RedoToggleElement extends HTMLElement {
  #root!: ShadowRoot;

  get root() {
    return this.#root;
  }

  connectedCallback() {
    const shadowRoot = this.attachShadow({ mode: "closed" });
    this.#root = shadowRoot;
  }

  disconnectedCallback() {
    this.dispatchEvent(new Event("disconnect"));
  }

  static #registered = false;

  static register() {
    if (!this.#registered) {
      customElements.define(this.TAG, this);
      this.#registered = true;
    }
  }

  static readonly TAG = "redo-shopify-toggle";
}
